import { render } from "./TakeawayCustomerPopup.vue?vue&type=template&id=a296576c&scoped=true"
import script from "./TakeawayCustomerPopup.vue?vue&type=script&lang=js"
export * from "./TakeawayCustomerPopup.vue?vue&type=script&lang=js"

import "./TakeawayCustomerPopup.vue?vue&type=style&index=0&id=a296576c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a296576c"]])

export default __exports__